import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminHandpicked = () => {
  const fields = [
    { name: 'tag', label: 'Tag', type: 'text', required: true, placeholder: 'e.g. Trending Now' },
    { name: 'title', label: 'Title', type: 'text', required: true, placeholder: 'e.g. Discover why Canberra needs to be visited', fullWidth: true },
    { name: 'destination', label: 'Destination', type: 'text', required: true, placeholder: 'e.g. Canberra' },
    { name: 'image', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'highlights', label: 'Highlights', type: 'array', placeholder: 'e.g. 🏛️ Culture\n🍷 Wine Trails\n🌿 Nature', fullWidth: true },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'image', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'tag', label: 'Tag' },
    { key: 'destination', label: 'Destination' },
    { key: 'title', label: 'Title' },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Handpicked Destinations"
      endpoint="handpicked-destinations"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminHandpicked;
